/* eslint-disable */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslations from "./locales/en.json";

const savedLanguage = localStorage.getItem("i18nextLng") || "en";

// Non-English bundles are code-split and fetched on demand to keep the initial JS payload small.
const langLoaders = {
	hi: () => import(/* webpackChunkName: "i18n-hi" */ "./locales/hi.json"),
	ja: () => import(/* webpackChunkName: "i18n-ja" */ "./locales/ja.json"),
	zh: () => import(/* webpackChunkName: "i18n-zh" */ "./locales/zh.json"),
};
// Tracks which language bundles are already registered with i18next to avoid duplicate imports.
const loadedLangs = new Set(["en"]);

async function loadLanguage(lng) {
	if (!lng || loadedLangs.has(lng) || !langLoaders[lng]) return;
	try {
		const mod = await langLoaders[lng]();
		i18n.addResourceBundle(lng, "translation", mod.default || mod, true, true);
		loadedLangs.add(lng);
	} catch (e) {
		// swallow — English fallback already loaded
	}
}

i18n.use(initReactI18next).init({
	resources: {
		en: { translation: enTranslations },
	},
	lng: savedLanguage,
	fallbackLng: "en",
	interpolation: {
		escapeValue: false,
	},
});

// Wrap changeLanguage so the target bundle is loaded before i18next switches to it.
const originalChangeLanguage = i18n.changeLanguage.bind(i18n);
i18n.changeLanguage = async (lng, ...rest) => {
	await loadLanguage(lng);
	return originalChangeLanguage(lng, ...rest);
};

// Preload the saved language on boot so initial render uses the user's prior selection instead of English.
if (savedLanguage && savedLanguage !== "en") {
	loadLanguage(savedLanguage);
}

export default i18n;
